import Schemas from './schemas';

export const OperationNames = Object.freeze({
  GET_ARTIST_DETAILS: 'GetArtistDetails',
  GET_ARTIST_COLLABORATIONS: 'GetArtistCollaborations',
  GET_ARTIST_DETAILS_WITH_COLLABORATIONS: 'GetArtistDetailsWithCollaborations',
  GET_COMPOSER_DETAILS: 'GetComposerDetails',
  GET_GENRE_CURATORS: 'GetGenreCurators',
  GET_PLAYLIST_CURATOR: 'GetPlaylistCurator',
  GET_PLAYLIST_CURATORS: 'GetPlaylistCurators',
  GET_CURATOR_DETAILS: 'GetCuratorDetails',
  GET_RECENTLY_PLAYED_SOURCES: 'GetRecentlyPlayedSources',
  GET_ALBUM_DETAILS: 'GetAlbumDetails',
  GET_ARTIST_DETAILS_WITH_CURATORS: 'GetArtistDetailsWithCurators',
  GET_STATION_CURATOR: 'GetStationCurator',
  GET_STATION_CURATORS: 'GetStationCurators',
  ADD_SEED_TO_STATION: 'AddSeedToStation',
  DELETE_SEED_FROM_STATION: 'DeleteSeedFromStation',
  UPDATE_STATION_DETAILS: 'UpdateStationDetails',
  REMOVE_FROM_LIBRARY: 'RemoveFromLibrary',
} as const);

// The GRAPHQL prefix is added to ensure there is no naming collision with other redux actions
export const OperationNameActions = Object.freeze({
  GRAPHQL_GET_ARTIST_DETAILS_ATTEMPT: 'GRAPHQL_GET_ARTIST_DETAILS_ATTEMPT',
  GRAPHQL_GET_ARTIST_DETAILS_SUCCESS: 'GRAPHQL_GET_ARTIST_DETAILS_SUCCESS',
  GRAPHQL_GET_ARTIST_DETAILS_FAIL: 'GRAPHQL_GET_ARTIST_DETAILS_FAIL',

  GRAPHQL_GET_ARTIST_COLLABORATIONS_ATTEMPT: 'GRAPHQL_GET_ARTIST_COLLABORATIONS_ATTEMPT',
  GRAPHQL_GET_ARTIST_COLLABORATIONS_SUCCESS: 'GRAPHQL_GET_ARTIST_COLLABORATIONS_SUCCESS',
  GRAPHQL_GET_ARTIST_COLLABORATIONS_FAIL: 'GRAPHQL_GET_ARTIST_COLLABORATIONS_FAIL',

  GRAPHQL_GET_ARTIST_DETAILS_WITH_COLLABORATIONS_ATTEMPT:
    'GRAPHQL_GET_ARTIST_DETAILS_WITH_COLLABORATIONS_ATTEMPT',
  GRAPHQL_GET_ARTIST_DETAILS_WITH_COLLABORATIONS_SUCCESS:
    'GRAPHQL_GET_ARTIST_DETAILS_WITH_COLLABORATIONS_SUCCESS',
  GRAPHQL_GET_ARTIST_DETAILS_WITH_COLLABORATIONS_FAIL:
    'GRAPHQL_GET_ARTIST_DETAILS_WITH_COLLABORATIONS_FAIL',

  GRAPHQL_GET_COMPOSER_DETAILS_ATTEMPT: 'GRAPHQL_GET_COMPOSER_DETAILS_ATTEMPT',
  GRAPHQL_GET_COMPOSER_DETAILS_SUCCESS: 'GRAPHQL_GET_COMPOSER_DETAILS_SUCCESS',
  GRAPHQL_GET_COMPOSER_DETAILS_FAIL: 'GRAPHQL_GET_COMPOSER_DETAILS_FAIL',

  GRAPHQL_GET_GENRE_CURATORS_ATTEMPT: 'GRAPHQL_GET_GENRE_CURATORS_ATTEMPT',
  GRAPHQL_GET_GENRE_CURATORS_SUCCESS: 'GRAPHQL_GET_GENRE_CURATORS_SUCCESS',
  GRAPHQL_GET_GENRE_CURATORS_FAIL: 'GRAPHQL_GET_GENRE_CURATORS_FAIL',

  GRAPHQL_GET_PLAYLIST_CURATOR_ATTEMPT: 'GRAPHQL_GET_PLAYLIST_CURATOR_ATTEMPT',
  GRAPHQL_GET_PLAYLIST_CURATOR_SUCCESS: 'GRAPHQL_GET_PLAYLIST_CURATOR_SUCCESS',
  GRAPHQL_GET_PLAYLIST_CURATOR_FAIL: 'GRAPHQL_GET_PLAYLIST_CURATOR_FAIL',

  GRAPHQL_GET_PLAYLIST_CURATORS_ATTEMPT: 'GRAPHQL_GET_PLAYLIST_CURATORS_ATTEMPT',
  GRAPHQL_GET_PLAYLIST_CURATORS_SUCCESS: 'GRAPHQL_GET_PLAYLIST_CURATORS_SUCCESS',
  GRAPHQL_GET_PLAYLIST_CURATORS_FAIL: 'GRAPHQL_GET_PLAYLIST_CURATORS_FAIL',

  GRAPHQL_GET_CURATOR_DETAILS_ATTEMPT: 'GRAPHQL_GET_CURATOR_DETAILS_ATTEMPT',
  GRAPHQL_GET_CURATOR_DETAILS_SUCCESS: 'GRAPHQL_GET_CURATOR_DETAILS_SUCCESS',
  GRAPHQL_GET_CURATOR_DETAILS_FAIL: 'GRAPHQL_GET_CURATOR_DETAILS_FAIL',

  GRAPHQL_GET_RECENTLY_PLAYED_SOURCES_ATTEMPT: 'GRAPHQL_GET_RECENTLY_PLAYED_SOURCES_ATTEMPT',
  GRAPHQL_GET_RECENTLY_PLAYED_SOURCES_SUCCESS: 'GRAPHQL_GET_RECENTLY_PLAYED_SOURCES_SUCCESS',
  GRAPHQL_GET_RECENTLY_PLAYED_SOURCES_FAIL: 'GRAPHQL_GET_RECENTLY_PLAYED_SOURCES_FAIL',

  GRAPHQL_GET_ALBUM_DETAILS_ATTEMPT: 'GRAPHQL_GET_ALBUM_DETAILS_ATTEMPT',
  GRAPHQL_GET_ALBUM_DETAILS_SUCCESS: 'GRAPHQL_GET_ALBUM_DETAILS_SUCCESS',
  GRAPHQL_GET_ALBUM_DETAILS_FAIL: 'GRAPHQL_GET_ALBUM_DETAILS_FAIL',

  GRAPHQL_GET_ARTIST_DETAILS_WITH_CURATORS_ATTEMPT:
    'GRAPHQL_GET_ARTIST_DETAILS_WITH_CURATORS_ATTEMPT',
  GRAPHQL_GET_ARTIST_DETAILS_WITH_CURATORS_SUCCESS:
    'GRAPHQL_GET_ARTIST_DETAILS_WITH_CURATORS_SUCCESS',
  GRAPHQL_GET_ARTIST_DETAILS_WITH_CURATORS_FAIL: 'GRAPHQL_GET_ARTIST_DETAILS_WITH_CURATORS_FAIL',

  GRAPHQL_GET_STATION_CURATOR_ATTEMPT: 'GRAPHQL_GET_STATION_CURATOR_ATTEMPT',
  GRAPHQL_GET_STATION_CURATOR_SUCCESS: 'GRAPHQL_GET_STATION_CURATOR_SUCCESS',
  GRAPHQL_GET_STATION_CURATOR_FAIL: 'GRAPHQL_GET_STATION_CURATOR_FAIL',

  GRAPHQL_GET_STATION_CURATORS_ATTEMPT: 'GRAPHQL_GET_STATION_CURATORS_ATTEMPT',
  GRAPHQL_GET_STATION_CURATORS_SUCCESS: 'GRAPHQL_GET_STATION_CURATORS_SUCCESS',
  GRAPHQL_GET_STATION_CURATORS_FAIL: 'GRAPHQL_GET_STATION_CURATORS_FAIL',

  GRAPHQL_ADD_SEED_TO_STATION_ATTEMPT: 'GRAPHQL_ADD_SEED_TO_STATION_ATTEMPT',
  GRAPHQL_ADD_SEED_TO_STATION_SUCCESS: 'GRAPHQL_ADD_SEED_TO_STATION_SUCCESS',
  GRAPHQL_ADD_SEED_TO_STATION_FAIL: 'GRAPHQL_ADD_SEED_TO_STATION_FAIL',

  GRAPHQL_DELETE_SEED_FROM_STATION_ATTEMPT: 'GRAPHQL_DELETE_SEED_FROM_STATION_ATTEMPT',
  GRAPHQL_DELETE_SEED_FROM_STATION_SUCCESS: 'GRAPHQL_DELETE_SEED_FROM_STATION_SUCCESS',
  GRAPHQL_DELETE_SEED_FROM_STATION_FAIL: 'GRAPHQL_DELETE_SEED_FROM_STATION_FAIL',

  GRAPHQL_UPDATE_STATION_DETAILS_ATTEMPT: 'GRAPHQL_UPDATE_STATION_DETAILS_ATTEMPT',
  GRAPHQL_UPDATE_STATION_DETAILS_SUCCESS: 'GRAPHQL_UPDATE_STATION_DETAILS_SUCCESS',
  GRAPHQL_UPDATE_STATION_DETAILS_FAIL: 'GRAPHQL_UPDATE_STATION_DETAILS_FAIL',

  GRAPHQL_REMOVE_FROM_LIBRARY_ATTEMPT: 'GRAPHQL_REMOVE_FROM_LIBRARY_ATTEMPT',
  GRAPHQL_REMOVE_FROM_LIBRARY_SUCCESS: 'GRAPHQL_REMOVE_FROM_LIBRARY_SUCCESS',
  GRAPHQL_REMOVE_FROM_LIBRARY_FAIL: 'GRAPHQL_REMOVE_FROM_LIBRARY_FAIL',
} as const);

export const OperationNameToSchemaMap = Object.freeze({
  [OperationNames.GET_ARTIST_DETAILS]: Schemas.GET_DETAILS,
  [OperationNames.GET_ARTIST_COLLABORATIONS]: Schemas.GET_DETAILS,
  [OperationNames.GET_ARTIST_DETAILS_WITH_COLLABORATIONS]: Schemas.GET_DETAILS,
  [OperationNames.GET_COMPOSER_DETAILS]: Schemas.GET_ANNOTATIONS,
  [OperationNames.GET_GENRE_CURATORS]: Schemas.GET_ANNOTATIONS,
  [OperationNames.GET_PLAYLIST_CURATOR]: Schemas.GET_ANNOTATIONS,
  [OperationNames.GET_PLAYLIST_CURATORS]: Schemas.GET_ANNOTATIONS,
  [OperationNames.GET_CURATOR_DETAILS]: Schemas.GET_DETAILS,
  [OperationNames.GET_RECENTLY_PLAYED_SOURCES]: Schemas.NO_ENTITY,
  [OperationNames.GET_ALBUM_DETAILS]: Schemas.GET_DETAILS,
  [OperationNames.GET_ARTIST_DETAILS_WITH_CURATORS]: Schemas.GET_DETAILS,
  [OperationNames.GET_STATION_CURATOR]: Schemas.GET_ANNOTATIONS,
  [OperationNames.GET_STATION_CURATORS]: Schemas.GET_ANNOTATIONS,
  [OperationNames.ADD_SEED_TO_STATION]: Schemas.NO_ENTITY,
  [OperationNames.DELETE_SEED_FROM_STATION]: Schemas.NO_ENTITY,
  [OperationNames.UPDATE_STATION_DETAILS]: Schemas.NO_ENTITY,
  [OperationNames.REMOVE_FROM_LIBRARY]: Schemas.NO_ENTITY,
} as const);
